'use client';

import { Arrow, Content, Portal, Root, Trigger } from '@radix-ui/react-popover';

import { cn } from '~/utils';
import { forwardRef } from 'react';

type PopoverContentProps = React.ComponentPropsWithoutRef<typeof Content> & {
    showArrow?: boolean;
};

const PopoverContent = forwardRef<React.ElementRef<typeof Content>, PopoverContentProps>(
    ({ className, align = 'center', sideOffset = 4, showArrow = false, ...props }, ref) => (
        <Portal>
            <Content
                ref={ref}
                align={align}
                sideOffset={sideOffset}
                className={cn(
                    'z-popovers rounded-4xl border bg-white p-8 shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                    className,
                )}
                {...props}
            >
                {props.children}
                {showArrow && <Arrow width={35} height={15} className="PopoverArrow text-white" />}
            </Content>
        </Portal>
    ),
);

PopoverContent.displayName = 'PopoverContent';

export { Root as Popover, Trigger as PopoverTrigger, PopoverContent };
